import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';



import MenuItem from '@material-ui/core/MenuItem';

import Menu from '@material-ui/core/Menu';
import { withStyles } from '@material-ui/core/styles';
import AccountIcon from '@material-ui/icons/AccountCircle';
import { Link } from 'react-router-dom';

const styles = theme => ({
  root: {
    display: 'flex',
  },
  paper: {
    marginRight: theme.spacing.unit * 2,
  },
  popperClose: {
    pointerEvents: 'none',
  },
  paperButton: {
    textTransform: 'none',
  },
});

class AccountMenu extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
    };

    this.handleClick = this.handleClick.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = (event) => {
    if (event.target.innerText.trim() === 'Logout') {
      this.props.onLogout(event);
    }
    this.setState({ anchorEl: null });
  };

  componentWillMount = () => {
    //console.log('in AccountMenu - componentWillMount: ' + this.props.username);
  }

  render() {
    const { classes, username } = this.props;
    const { anchorEl } = this.state;

    return (
      <div>
        <Button color="inherit"
          className={classes.paperButton}
          aria-owns={anchorEl ? 'simple-menu' : null}
          aria-haspopup="true"
          onClick={this.handleClick}
        >
          <AccountIcon/>
            <Typography style={{marginLeft: '4px'}} variant="subheading" color="inherit" noWrap>
              {username}
            </Typography>
        </Button>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
        >
          <MenuItem onClick={this.handleClose} key="0" component={Link} to={'/favorites'}>Favorites</MenuItem>
          <MenuItem onClick={this.handleClose} key="1"component={Link} to={'/settings'}>Settings</MenuItem>
          <MenuItem onClick={this.handleClose} key="2">Logout</MenuItem>
        </Menu>
      </div>
    );
  }
}

AccountMenu.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AccountMenu);



// WEBPACK FOOTER //
// ./src/components/dashboard/AccountMenu.jsx